import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Button from '../shared/Button.svelte';
import { logDiaper, getDiaperCountToday } from '../../lib/services/health';
import { getActiveChild } from '../../lib/stores/children.svelte.ts';
import { showToast } from '../shared/Toast.svelte';

var root = $.from_html(`<div class="diaper-log svelte-2hs4kjv9w8xoy"><div class="diaper-buttons svelte-2hs4kjv9w8xoy"><button class="diaper-btn svelte-2hs4kjv9w8xoy"><span class="diaper-icon svelte-2hs4kjv9w8xoy">💧</span> <span class="diaper-label svelte-2hs4kjv9w8xoy">Wet</span></button> <button class="diaper-btn svelte-2hs4kjv9w8xoy"><span class="diaper-icon svelte-2hs4kjv9w8xoy">💩</span> <span class="diaper-label svelte-2hs4kjv9w8xoy">Dirty</span></button> <button class="diaper-btn svelte-2hs4kjv9w8xoy"><span class="diaper-icon svelte-2hs4kjv9w8xoy">💧💩</span> <span class="diaper-label svelte-2hs4kjv9w8xoy">Both</span></button></div> <p class="diaper-count svelte-2hs4kjv9w8xoy"> </p></div>`);

function DiaperLog($$anchor, $$props) {
	$.push($$props, true);

	const activeChild = $.derived(getActiveChild);
	let counts = $.state($.proxy({ wet: 0, dirty: 0, total: 0 }));

	$.user_effect(() => {
		if (!$.get(activeChild)) return;

		loadCounts();
	});

	async function loadCounts() {
		if (!$.get(activeChild)) return;

		$.set(counts, await getDiaperCountToday($.get(activeChild).id), true);
	}

	async function handleLog(type) {
		if (!$.get(activeChild)) {
			showToast('No active child selected.', 'error');

			return;
		}

		try {
			await logDiaper($.get(activeChild).id, type);
			await loadCounts();
			showToast('Diaper logged', 'success');
			$$props.onlogged?.();
		} catch(e) {
			showToast('Failed to log diaper. Please try again.', 'error');
		}
	}

	var div = root();
	var div_1 = $.child(div);
	var button = $.child(div_1);
	var button_1 = $.sibling(button, 2);
	var button_2 = $.sibling(button_1, 2);

	$.reset(div_1);

	var p = $.sibling(div_1, 2);
	var text = $.child(p);

	$.reset(p);
	$.reset(div);
	$.template_effect(() => $.set_text(text, `Today: ${$.get(counts).wet ?? ''} wet, ${$.get(counts).dirty ?? ''} dirty (${$.get(counts).total ?? ''} total)`));
	$.delegated('click', button, () => handleLog('wet'));
	$.delegated('click', button_1, () => handleLog('dirty'));
	$.delegated('click', button_2, () => handleLog('both'));
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	DiaperLog = $.hmr(DiaperLog);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-2hs4kjv9w8xoy');
		DiaperLog[$.HMR].update(module.default);
	});
}

export default DiaperLog;

$.delegate(['click']);
import "bun-svelte:DiaperLog.svelte-13eu0jontbzja-style.css";